<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="day-shift">
                    <icon name="sun"></icon>
                    กะกลางวัน
                </b-nav-item>&nbsp
                <b-nav-item router-link to="night-shift">
                    <icon name="moon"></icon>
                    กะกลางคืน
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "material-inspect-layout"
    }
</script>

<style scoped>

</style>